import { reactive } from 'vue'
import tools from '@/composables/tools'

export const videosDescargaUi = reactive({
    visible: false,
    disabled: true,
    label: 'Descargar',
    run: () => undefined,
})

let t0 = 0
let origen = ''

export const markAccesoVideosDescarga = (desde: string) => {
    t0 = typeof performance !== 'undefined' ? performance.now() : Date.now()
    origen = desde
}

export const logVistaVideosDescarga = () => {
    if (!t0) return
    const now = typeof performance !== 'undefined' ? performance.now() : Date.now()
    const ms = Math.round(now - t0)
    const desde = origen || 'directo'
    t0 = 0
    origen = ''
    tools().setLog(
        `Accede a descargar vídeos y ve la vista en ${ms} ms (${desde})`,
        'info',
        { action: 'videos_descarga_vista', model: 'video' }
    )
}
